import { Helmet } from 'react-helmet-async';
import { googleAnalyticsConfig, hotJarId } from '../../config';
import Hotjar from '@hotjar/browser';

// ----------------------------------------------------------------------

const GA_MEASUREMENT_ID = googleAnalyticsConfig;
const HOTJAR_ID = hotJarId;

export default function GoogleAnalytics() {
  const siteId = HOTJAR_ID;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);
  console.log('Hot jar initialized', siteId);

  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </script>
    </Helmet>
  );
}
